import {ReactComponent as IconDiscord} from "assets/icons/socials/discord.svg";
import {ReactComponent as IconFacebook} from "assets/icons/socials/facebook.svg";
import {ReactComponent as IconInstagram} from "assets/icons/socials/instagram.svg";
import {ReactComponent as IconLinkedin} from "assets/icons/socials/linkedin.svg";
import {ReactComponent as IconMedium} from "assets/icons/socials/medium.svg";
import {ReactComponent as IconOpensea} from "assets/icons/socials/opensea.svg";
import {ReactComponent as IconReddit} from "assets/icons/socials/reddit.svg";
import {ReactComponent as IconTiktok} from "assets/icons/socials/tiktok.svg";
import {ReactComponent as IconTwitter} from "assets/icons/socials/twitter.svg";
import {ReactComponent as IconYoutube} from "assets/icons/socials/youtube.svg";
import {ReactComponent as IconColorFacebook} from "assets/icons/social-networks-for-voting/facebook.svg";
import {ReactComponent as IconColorInstagram} from "assets/icons/social-networks-for-voting/instagram.svg";
import {ReactComponent as IconColorTiktok} from "assets/icons/social-networks-for-voting/tiktok.svg";
import {ReactComponent as IconColorTwitter} from "assets/icons/social-networks-for-voting/twitter.svg";
import {ReactComponent as IconColorYoutube} from "assets/icons/social-networks-for-voting/youtube.svg";

const socials = {
    IconDiscord,
    IconFacebook,
    IconInstagram,
    IconLinkedin,
    IconMedium,
    IconOpensea,
    IconReddit,
    IconTiktok,
    IconTwitter,
    IconYoutube,
    IconColorFacebook,
    IconColorInstagram,
    IconColorTiktok,
    IconColorTwitter,
    IconColorYoutube
};

export default socials;

export type IconsSocialsType = keyof typeof socials;
